import { useCallback, useContext, useEffect } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import {
    Container,
    IStep,
    IStepperContext,
    Indicator,
    Separator,
    Step as StepPrimitive,
    StepProps as StepPrimitiveProps,
    Stepper,
    StepperContext,
    StepperIndicator,
    StepperProvider as StepperProviderPrimitive,
    StepperProviderProps as StepperProviderPrimitiveProps,
    StepperSeparator,
    StepperSeparatorProps,
    StepperText,
    StepperTextProps,
    Text,
} from '@givebutter/primitives/stepper';

interface StepMeta {
    path: string;
}

interface StepperProviderProps extends StepperProviderPrimitiveProps<StepMeta> {}
const StepperProvider = ({ children, ...rest }: StepperProviderProps) => {
    const history = useHistory();

    const onUpdateStep = useCallback(
        (nextStep: IStep<StepMeta>) => {
            if (nextStep.meta?.path) {
                history.push(nextStep.meta?.path);
            }
        },
        [history],
    );

    return (
        <StepperProviderPrimitive onUpdateStep={onUpdateStep} {...rest}>
            {children}
        </StepperProviderPrimitive>
    );
};

interface StepProps extends StepPrimitiveProps<StepMeta> {}

const Step = (props: StepProps) => {
    const { meta, value, ...rest } = props;
    const { goTo, getStepIndex } = useContext(StepperContext);
    const isActive = !!useRouteMatch(meta?.path ?? [])?.isExact;
    const stepIndex = getStepIndex(value);

    useEffect(() => {
        if (isActive && stepIndex >= 0) {
            goTo(stepIndex);
        }
    }, [goTo, isActive, stepIndex]);

    return <StepPrimitive meta={{ path: meta?.path }} value={value} {...rest} />;
};

const Root = StepperProvider;

export {
    StepperContext,
    //
    Root,
    Container,
    Separator,
    Text,
    Indicator,
    //
    StepperProvider,
    Stepper,
    Step,
    StepperSeparator,
    StepperText,
    StepperIndicator,
};

export type {
    IStep,
    IStepperContext,
    StepperProviderProps,
    StepperSeparatorProps,
    StepperTextProps,
    StepProps,
};
